<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<td [class.ignore-opacity]="isCurrentlyEditing || isCurrentlyProtectOrderEditing">
  <div class="d-flex">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.positions.labels.assetName' | transloco }}
    </div>
    <div class="d-inline-flex text-md-left text-right">
      <web-components-instrument-details-link class="font-medium" [isin]="item.isin">
        {{ item.assetName }}
      </web-components-instrument-details-link>
    </div>
  </div>
  <div class="d-flex text-color-primary">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.positions.labels.isin' | transloco }}
    </div>
    <div class="font-light">{{ item.isin }}</div>
    @if (actionsEnabled) {
      <web-components-watchlist-toggle [isin]="item.isin" />
    }
  </div>
</td>
@if (!isEditEntryQuoteMode) {
  <td [class.ignore-opacity]="isCurrentlyProtectOrderEditing">
    <div class="d-flex justify-content-end">
      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
        {{ 'mydepot.depotoverview.positions.labels.quantity' | transloco }}
      </div>
      <div>{{ item.quantity | number: '1.0-8' }}</div>
    </div>
    @if (protectOrderVisible) {
      <div class="d-flex text-color-primary justify-content-end">
        <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
          {{ 'mydepot.depotoverview.positions.labels.availableProtections' | transloco }}
        </div>
        <div [ngClass]="item.availableQuantity >= 1 ? 'cursor-pointer' : 'cursor-default'" (click)="protectOrder()">
          @if (item.orderExecutionTypesForProtection?.length) {
            @if (item.orderExecutionTypesForProtection.length === 1) {
              <div
                [ngbTooltip]="tooltipContent"
                tooltipClass="without-arrow"
                triggers="hover"
                placement="bottom"
                class="protect-order-status with-protection"
                [ngClass]="
                  ['limit', 'market'].indexOf(item.orderExecutionTypesForProtection[0].orderExecutionType) > -1
                    ? 'limit'
                    : 'with-protection'
                "
              >
                {{
                  'mydepot.depotoverview.positions.protect-order.types.' + item.orderExecutionTypesForProtection[0].orderExecutionType
                    | transloco
                }}
                {{ item.orderExecutionTypesForProtection[0].protectedQuantityByOrderExecutionType | number: '1.0-0' }}
              </div>
            } @else {
              <div
                [ngbTooltip]="tooltipContent"
                tooltipClass="without-arrow"
                triggers="hover"
                placement="bottom"
                class="protect-order-status with-protection"
              >
                {{
                  'mydepot.depotoverview.positions.protect-order.multiple-protection'
                    | transloco: { quantity: sumProtection | number: '1.0-0' }
                }}
              </div>
            }
          } @else {
            @if (item.isSellable) {
              <div
                [ngbTooltip]="item.availableQuantity >= 1 ? tooltipContent : tooltipNoneAvailableContent"
                tooltipClass="without-arrow"
                triggers="hover"
                placement="bottom"
                class="protect-order-status no-protection"
              >
                {{ 'mydepot.depotoverview.positions.protect-order.no-protection' | transloco }}
              </div>
            }
          }
        </div>
      </div>
    } @else {
      <div class="d-flex text-color-primary justify-content-end">
        <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
          {{ 'mydepot.depotoverview.positions.labels.availableQuantity' | transloco }}
        </div>
        <div>{{ item.availableQuantity | number: '1.0-8' }}</div>
      </div>
    }
    <ng-template #tooltipContent>
      @for (protection of item.orderExecutionTypesForProtection ?? []; track $index) {
        @if (protection.orderExecutionType === 'limit' || protection.orderExecutionType === 'market') {
          <div class="text-left">
            {{
              'mydepot.depotoverview.positions.protect-order.tooltip-limit'
                | transloco
                  : {
                      quantity: protection.protectedQuantityByOrderExecutionType | number: '1.0-0',
                      orderType: 'mydepot.depotoverview.positions.protect-order.types-tooltip.' + protection.orderExecutionType | transloco,
                    }
            }}
          </div>
        } @else {
          <div class="text-left">
            {{
              'mydepot.depotoverview.positions.protect-order.tooltip'
                | transloco
                  : {
                      quantity: protection.protectedQuantityByOrderExecutionType | number: '1.0-0',
                      orderType: 'mydepot.depotoverview.positions.protect-order.types-tooltip.' + protection.orderExecutionType | transloco,
                    }
            }}
          </div>
        }
      }
      @if (item.availableQuantity >= 1) {
        <div class="text-left">{{ 'mydepot.depotoverview.positions.protect-order.tooltip-click' | transloco }}</div>
      }
    </ng-template>
    <ng-template #tooltipNoneAvailableContent>
      <div class="text-left">{{ 'mydepot.depotoverview.positions.protect-order.tooltip-none-available' | transloco }}</div>
    </ng-template>
    <ng-template #availableQuantity>
      <div class="d-flex text-color-primary justify-content-end">
        <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
          {{ 'mydepot.depotoverview.positions.labels.availableQuantity' | transloco }}
        </div>
        <div>{{ item.availableQuantity | number: '1.0-8' }}</div>
      </div>
    </ng-template>
  </td>
}
<td [class.ignore-opacity]="isCurrentlyEditing || isCurrentlyProtectOrderEditing">
  @if (isCurrentlyEditing) {
    <div class="d-flex justify-content-between">
      <div class="text-nowrap font-medium">
        {{ 'mydepot.depotoverview.positions.editable-entry-quotes.customQuote' | transloco }}
      </div>
      <div>
        <input
          #entryQuote
          type="text"
          inputmode="numeric"
          [(ngModel)]="currentEntryQuote"
          [class.error]="isEntryQuoteError"
          class="max-w-100 text-right"
        />
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-between">
      <div
        class="text-nowrap"
        [ngbTooltip]="'mydepot.depotoverview.positions.editable-entry-quotes.avgEntryQuote.tooltip' | transloco"
        tooltipClass="zero-tooltip"
        triggers="hover"
        placement="bottom"
      >
        {{ 'mydepot.depotoverview.positions.editable-entry-quotes.avgEntryQuote.label' | transloco }}
      </div>
      <div class="ml-2">
        {{ item.avgEntryQuoteOriginal | currency: 'EUR' : 'symbol' : '1.2-3' }}
      </div>
    </div>
    <div class="d-flex justify-content-end align-items-center mt-2">
      <a class="link-secondary cursor-pointer text-uppercase mr-4" (click)="updateEntryQuote.emit(item.avgEntryQuote)">
        {{ 'mydepot.depotoverview.positions.editable-entry-quotes.cancel' | transloco }}
      </a>
      <web-design-system-button size="small" (click)="validateEntryQuoteAndUpdate()">
        {{ 'mydepot.depotoverview.positions.editable-entry-quotes.save' | transloco }}
      </web-design-system-button>
    </div>
  } @else {
    <div class="d-flex justify-content-end">
      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
        {{ 'mydepot.depotoverview.positions.labels.avgEntryQuote' | transloco }}
      </div>
      <div class="text-color-primary">
        {{ item.avgEntryQuote | currency: 'EUR' : 'symbol' : '1.2-3' }}
      </div>
    </div>
    <div class="d-flex text-color-primary justify-content-end">
      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
        {{ 'mydepot.depotoverview.positions.labels.entryValue' | transloco }}
      </div>
      <div class="text-color-primary">
        {{ item.entryValue | currency }}
      </div>
    </div>
  }
</td>
<td
  [ngClass]="{
    'hidden-sm hidden-xs': item.endfaellig || item.knockedOutFlag,
  }"
  [class.ignore-opacity]="isCurrentlyProtectOrderEditing"
>
  @if (!item.endfaellig && !item.knockedOutFlag) {
    <div class="d-flex justify-content-end">
      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
        {{ 'mydepot.depotoverview.positions.labels.quote' | transloco }}
      </div>
      <div class="text-color-primary" [zeroBlink]="!isCurrentlyEditing" [val]="item.quote">
        @if (item.quote < 50) {
          {{ item.quote | currency: 'EUR' : 'symbol' : '1.3' }}
        } @else {
          {{ item.quote | currency: 'EUR' : 'symbol' : '1.2' }}
        }
      </div>
    </div>
    <div class="d-flex text-color-primary justify-content-end">
      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
        {{ 'mydepot.depotoverview.positions.labels.currentValue' | transloco }}
      </div>
      <div class="text-color-primary">
        {{ item.currentValue | currency }}
      </div>
    </div>
  }
</td>
<td
  [ngClass]="{
    'hidden-sm hidden-xs': item.endfaellig || item.knockedOutFlag,
  }"
  [class.ignore-opacity]="isCurrentlyProtectOrderEditing"
>
  @if (!item.endfaellig && !item.knockedOutFlag) {
    <div class="d-flex justify-content-end">
      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
        {{ 'mydepot.depotoverview.positions.labels.perfTodayPct' | transloco }} <br />
        {{ 'mydepot.depotoverview.positions.labels.perfTodayAbs' | transloco }}
      </div>
      <div class="text-right">
        <div
          [class.text-color-success]="item.perfTodayAbs >= 0"
          [class.text-color-error]="item.perfTodayAbs < 0"
          [zeroBlink]="!isCurrentlyEditing"
          [val]="item.perfTodayAbs"
        >
          {{ item.perfTodayPct | number: '1.2-2' }}&nbsp;%
        </div>
        <div [class.text-color-success]="item.perfTodayAbs >= 0" [class.text-color-error]="item.perfTodayAbs < 0">
          {{ item.perfTodayAbs | currency }}
        </div>
      </div>
    </div>
  }
</td>
<td
  [ngClass]="{
    'hidden-sm hidden-xs': item.endfaellig || item.knockedOutFlag,
  }"
  [class.ignore-opacity]="isCurrentlyProtectOrderEditing"
>
  @if (!item.endfaellig && !item.knockedOutFlag) {
    <div class="d-flex justify-content-end">
      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
        {{ 'mydepot.depotoverview.positions.labels.perfPct' | transloco }} <br />
        {{ 'mydepot.depotoverview.positions.labels.perfAbs' | transloco }}
      </div>
      <div class="text-right">
        <div
          [class.text-color-success]="item.perfAbs >= 0"
          [class.text-color-error]="item.perfAbs < 0"
          [zeroBlink]="!isCurrentlyEditing"
          [val]="item.perfAbs"
        >
          {{ item.perfPct | number: '1.2-2' }}&nbsp;%
        </div>
        <div [class.text-color-success]="item.perfAbs >= 0" [class.text-color-error]="item.perfAbs < 0">
          {{ item.perfAbs | currency }}
        </div>
      </div>
    </div>
  }
</td>
<td
  [ngClass]="{
    'hidden-sm hidden-xs': item.endfaellig || item.knockedOutFlag,
  }"
  [class.ignore-opacity]="isCurrentlyProtectOrderEditing"
>
  @if (!item.endfaellig && !item.knockedOutFlag) {
    <div>
      <div class="d-flex justify-content-end">
        <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
          {{ 'mydepot.depotoverview.positions.labels.quoteTime' | transloco }}
        </div>
        <div class="text-color-primary">
          {{ item.quoteTime | date: 'mediumTime' }}
        </div>
      </div>
      <div class="d-flex text-color-primary justify-content-end">
        <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
          {{ 'mydepot.depotoverview.positions.labels.quoteDate' | transloco }}
        </div>
        <div class="text-color-primary">
          {{ item.quoteTime | date: 'shortDate' }}
        </div>
      </div>
    </div>
  }
</td>
@if (actionsEnabled && !isEditEntryQuoteMode) {
  <td class="margin-xs-bottom-15 margin-sm-bottom-15">
    <div class="d-flex justify-content-end">
      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow padding-top-10">
        {{ 'mydepot.depotoverview.positions.labels.trade' | transloco }}
      </div>
      <div class="d-flex justify-content-end align-items-center">
        <div ngbDropdown class="d-inline-block" placement="bottom-right">
          <button
            [disabled]="isCurrentlyAddTagMode"
            class="btn-icon cursor-pointer"
            (click)="cancelTagMode.emit()"
            id="dropdown"
            ngbDropdownToggle
          >
            <svg class="icon icon-21 text-primary">
              <use xlink:href="/assets/img/svgs/svgset.svg#dots" />
            </svg>
          </button>
          @if (!isEditProtectOrderMode) {
            <div ngbDropdownMenu aria-labelledby="dropdown" [class.position-dropdown]="item.isBuyable || item.isSellable">
              <button ngbDropdownItem (click)="editEntryQuote.emit()" class="d-flex gap-half">
                <svg class="icon icon-24 color-secondary">
                  <use xlink:href="/assets/img/svgs/svgset.svg#edit-pencil" />
                </svg>
                {{ 'mydepot.depotoverview.positions.edit-entry' | transloco }}
              </button>
              <button ngbDropdownItem (click)="addTagMode.emit()" class="d-flex gap-half">
                <web-design-system-icon name="tag" color="action" />
                {{ 'mydepot.depotoverview.positions.add-tag' | transloco }}
                <web-design-system-pill type="new">
                  {{ 'mydepot.depotoverview.positions.settings.newBadge' | transloco | uppercase }}
                </web-design-system-pill>
              </button>
              <button ngbDropdownItem (click)="editNote.emit()" class="d-flex gap-half">
                <svg class="icon icon-24 color-secondary">
                  <use xlink:href="/assets/img/svgs/svgset.svg#edit-note" />
                </svg>
                {{ 'mydepot.depotoverview.positions.add-note' | transloco }}
              </button>
              <button
                ngbDropdownItem
                (click)="protectOrder()"
                [disabled]="!item.isSellable || item.availableQuantity < 1"
                class="d-flex gap-half"
              >
                <svg
                  class="icon icon-24"
                  [class.text-disabled]="!item.isSellable || item.availableQuantity < 1"
                  [class.color-secondary]="item.isSellable && item.availableQuantity >= 1"
                >
                  <use xlink:href="/assets/img/svgs/svgset.svg#protect-order" />
                </svg>
                {{ 'mydepot.depotoverview.positions.add-protection' | transloco }}
              </button>
              <button ngbDropdownItem [routerLink]="instrumentDetail + '/' + item.isin + '/timeline'" class="d-flex gap-half">
                <web-design-system-icon name="timeline" color="action" />
                {{ 'mydepot.depotoverview.positions.timeline' | transloco }}
              </button>
            </div>
          }
        </div>
        @if (item.isBuyable) {
          <div
            class="trade buy cursor-pointer"
            title="Kaufen"
            data-zid="buy-action"
            [routerLink]="isEditProtectOrderMode ? null : commonRoutes.postlogin.buyAndSell"
            [queryParams]="{ isin: item.isin, direction: 'buy' }"
          >
            K
          </div>
        }
        @if (item.isSellable) {
          <div
            class="trade sell cursor-pointer"
            title="Verkaufen"
            data-zid="sell-action"
            [routerLink]="isEditProtectOrderMode ? null : commonRoutes.postlogin.buyAndSell"
            [queryParams]="{
              isin: item.isin,
              direction: 'sell',
              quantity: item.availableQuantity,
            }"
          >
            V
          </div>
        }
        @if (item.endfaellig || item.knockedOutFlag) {
          <div class="d-flex justify-content-end">
            <div class="text-color-primary">Wartet auf<br />Einlösung</div>
          </div>
        }
      </div>
    </div>
  </td>
}
